module.exports = {"id":"194947","name":"Jagoš Vuković","rating":"75","photo":"./data/images/photos/1/194947.png","club":{"name":"Hellas Vérone","logo":"./data/images/clubs/HellasVerone.png"},"positions":["DC"],"photoFolderIndex":1}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/JagosVukovic0.json
// module id = 1873
// module chunks = 0